import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { vismaStatusTemplate } from 'apollo/templates/visma';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { vismaStatusVar } from 'apollo/reactive-variables/invoice';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

const VismaAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['common', 'invoices']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [vismaAuthUrl, setVismaAuthUrl] = useState('');
    const vismaFrontendStatus = vismaStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('visma-auth-callback');

    useQuery(vismaStatusTemplate, {
        onCompleted: ({ vismaStatus }) => {
            vismaStatusVar(vismaStatus);
            if (vismaStatus.enabled && !vismaStatus.authorized && !isCurrentlyAuthorizing) {
                const state = new Date().getTime().toString();
                localStorage.setItem(CONSTANTS.VISMA_TEMP_STATE_KEY, state);
                setDialogOpen(true);
                setVismaAuthUrl(
                    `${CONSTANTS.VISMA_AUTH_URL}?client_id=${vismaStatus.clientId}&redirect_uri=${CONSTANTS.VISMA_REDIRECT_URL}&state=${state}&scope=ea:api+offline_access+ea:sales&response_type=code`,
                );
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {vismaFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('invoices:YOU_NEED_TO_LOGIN_TO_VISMA')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('invoices:VISMA_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={vismaAuthUrl}>
                            {translate('invoices:LOGIN_TO_VISMA')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default VismaAuthContainer;
